import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategorySection() {
  return (
    <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-900 mb-3">
            内容分类导航
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            六大核心板块，全面覆盖黄瓜种植、品种、病虫害、行情、种子与加工储存
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group flex items-start gap-4 p-5 md:p-6 bg-background-50 border border-background-200 rounded-lg hover:border-primary-300 hover:bg-primary-50/50 transition-all duration-200 cursor-pointer"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 flex-shrink-0 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                <i className={`${cat.icon} text-xl md:text-2xl`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="font-heading font-semibold text-foreground-900 text-sm md:text-base mb-1 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                  {cat.name}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2 mb-2">
                  {cat.description}
                </p>
                <span className="text-xs text-primary-500 font-medium whitespace-nowrap">
                  {cat.articleCount} 篇文章
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}